import { Tag, Filter, Plus, TicketPercent } from "lucide-react";
import SelectField from "../common/SelectField";
import SearchBar from "../common/SearchBar";

export default function PromoHeader({ 
  total, 
  search, 
  onSearch, 
  statusFilter, 
  onStatusChange, 
  typeFilter, 
  onTypeChange,
  onAdd,
}) {
  return (
    <div className="pageHeader">
      <div className="headerTop">
        <div className="pageTitle">
          <div className="titleWithIcon">
            <Tag size={24} className="primaryIcon" />
            <h2>Gestion des Promotions</h2>
          </div>
          <span className="countBadge">{total} Codes</span>
        </div>
        <button className="btnPrimary" onClick={onAdd}>
          <Plus size={18} /> Créer une promotion
        </button>
      </div>

      <div className="filterActionsRow">
        <div className="selectorsGrid">
          {/* Filtre par État de validité */}
          <SelectField
            icon={Filter}
            value={statusFilter}
            onChange={onStatusChange}
            options={[
              { label: "Tous les états", value: "all" },
              { label: "Actives", value: "active" },
              { label: "Planifiées", value: "scheduled" },
              { label: "Expirées", value: "expired" },
            ]}
          />
          {/* Filtre par Type de remise */}
          <SelectField
            icon={TicketPercent}
            value={typeFilter}
            onChange={onTypeChange}
            options={[
              { label: "Tous les types", value: "all" },
              { label: "Pourcentage (%)", value: "percentage" },
              { label: "Montant fixe (CFA)", value: "amount" },
            ]}
          />
        </div>

        <div className="searchWrapper">
          <SearchBar
            value={search}
            onChange={onSearch}
            placeholder="Rechercher par code..."
          />
        </div>
      </div>
    </div>
  );
}